import { Portal, Provider, Root, Trigger } from "@radix-ui/react-tooltip";
import { Body } from "../body/Body";
import { Arrow, Content, Props, TipText } from "./Tooltip.Parts";

export const Tooltip = ({
  children,
  tip,
  defaultOpen,
  open,
  onOpenChange = () => {
    // do nothing by default
  },
  delayDuration = 300,
  collisionPadding = 4,
  sideOffset = 5,
  side = "top",
  align = "center",
}: Props) => {
  if (!tip) return children;

  return (
    <Provider>
      <Root
        delayDuration={delayDuration}
        onOpenChange={onOpenChange}
        defaultOpen={defaultOpen}
        open={open}
      >
        <Trigger asChild>
          {/* Child of Trigger needs to be an element but ReactNode can be a string so adding a type check to wrap span */}
          {typeof children === "string" ? <span>{children}</span> : children}
        </Trigger>
        <Portal>
          <Content
            sideOffset={sideOffset}
            collisionPadding={collisionPadding}
            side={side}
            align={align}
          >
            <TipText>
              <Body variant="xsmall-strong">{tip}</Body>
            </TipText>
            <Arrow />
          </Content>
        </Portal>
      </Root>
    </Provider>
  );
};
